export default __webpack_public_path__ + "static/media/success_sensor.0b9f7235.svg";